import React from "react";
import { Button, CardBody, Text } from "@jarvis-catalyst/ui-components";
import LoadingComponent from "../../../components/Loading";
import { countriesOptionsList, getListBusinessAliases, purposeOptionsList } from "../../../utils/listOptions";
import { useForm } from "react-hook-form";
import { useServiceProviders } from "../../../hooks/useServiceProviders";
import { usePurposeList } from "../../../hooks/usePurposeList";
import { useNavigate } from "react-router";

type Inputs = {
  country?: string;
  business?: string;
  purposeName?: string;
  page?: number;
  limit?: number;
};

interface Props {
  onSearch: (data: Inputs) => void;
  setForm: React.Dispatch<React.SetStateAction<Partial<Inputs>>>;
}

const SearchConsentForm: React.FC<Props> = ({ onSearch, setForm }) => {
  const navigate = useNavigate();
  const { serviceProviderUseQuery } = useServiceProviders();
  const { purposeListUseQuery } = usePurposeList();
  const { isLoading: loadingPurpose } = purposeListUseQuery;

  const {
    formState: { errors },
    getValues,
    register
  } = useForm<Inputs>({
    defaultValues: { business: "", country: "", purposeName: "" }
  });

  return (
    <CardBody>
      <div className="row">
        <div className="col">
          <Text>País</Text>
          {serviceProviderUseQuery.isLoading ? (
            <LoadingComponent height="25px" width="25px" marginTop="0px" />
          ) : (
            <select
              className={`form-select ${errors.country ? "is-invalid" : ""}`}
              {...register("country", { required: true })}
            >
              <option value="">Seleccione País</option>
              {countriesOptionsList(serviceProviderUseQuery.data).map((item, index) => (
                <option key={index} value={item.label}>
                  {item.label}
                </option>
              ))}
            </select>
          )}
        </div>

        <div className="col">
          <Text>Negocio</Text>
          {serviceProviderUseQuery.isLoading ? (
            <LoadingComponent height="25px" width="25px" marginTop="0px" />
          ) : (
            <select
              className={`form-select ${errors.business ? "is-invalid" : ""}`}
              {...register("business", { required: true })}
            >
              <option value="">Seleccione Negocio</option>
              {getListBusinessAliases(serviceProviderUseQuery.data).map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>

      <div className="row mt-3">
        <div className="col">
          <Text>Punto de Captura</Text>
          {purposeListUseQuery.isLoading ? (
            <LoadingComponent height="25px" width="25px" marginTop="0px" />
          ) : (
            <>
              <input
                type="text"
                className={`form-select ${errors.purposeName ? "is-invalid" : ""}`}
                {...register("purposeName", { required: true })}
                placeholder="Seleccione un Punto de Captura"
                list="list-experience"
              />
              <datalist id="list-experience">
                {purposeOptionsList(purposeListUseQuery.data).map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label} - {item.value}
                  </option>
                ))}
              </datalist>
            </>
          )}
        </div>
      </div>

      {!loadingPurpose && (
        <div className="d-grid mt-4">
          <Button
            color="primary"
            className="text-center"
            type="button"
            onClick={() => {
              onSearch(getValues());
              setForm(getValues());
            }}
          >
            Buscar consentimiento
          </Button>
        </div>
      )}
      <div className="d-grid mt-2">
        <Button
          className="text-center text-uppercase"
          color="bordered"
          type="button"
          onClick={() => navigate("/")}
        >
          Volver
        </Button>
      </div>
    </CardBody>
  );
};

export default SearchConsentForm;
